import { makeAutoObservable } from 'mobx'
import { numberFormat } from 'shared/lib'
import { type IResponseOneTimeBroadcast } from 'entities/Broadcast/api/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { BroadcastBaseStatistic } from 'entities/Broadcast/model/BroadcastBaseStatistic'

export class BroadcastOneTimeStatistic {
  readonly broadcastBaseStatistic: BroadcastBaseStatistic
  constructor(
    {
      contacts_count,
      all_statistics,
      short_urls,
      analytics,
      is_track_conversion,
    }: IResponseOneTimeBroadcast,
    private _entities: IEntitiesStore
  ) {
    const statistic = all_statistics
    const unsubscribed_count = statistic?.opt_out_count ?? null
    const no_replies_count = statistic?.no_replies_count ?? null
    const reply_count = statistic?.reply_count ?? null
    const success_count = statistic?.success_count || 0
    const total_count = statistic?.total_count || 0
    const in_progress_count = statistic?.in_progress_count ?? null
    const quiet_hours_count = statistic?.quiet_hours_count || 0
    const skipped_count = statistic?.skipped_count ?? null
    const failed_count = statistic?.failed_count ?? null
    const clicks_count = short_urls?.length
      ? short_urls.reduce((acc, cur) => acc + cur.clicks, 0)
      : null

    const conversions_count = analytics?.users_with_conversion || (is_track_conversion ? 0 : null)

    let revenue_cost: string | null

    if (analytics?.conversion_value) {
      revenue_cost = numberFormat({
        value: analytics?.conversion_value,
        minimumFractionDigits: 0,
        currency: 'USD',
      })
    } else {
      revenue_cost = is_track_conversion
        ? numberFormat({
            minimumFractionDigits: 0,
            value: 0,
            currency: 'USD',
          })
        : null
    }
    this.broadcastBaseStatistic = new BroadcastBaseStatistic(this._entities, {
      contacts_count,
      is_track_conversion,
      total_count,
      in_progress_count,
      quiet_hours_count,
      success_count,
      skipped_count,
      reply_count,
      no_replies_count,
      clicks_count,
      conversions_count,
      revenue_cost,
      failed_count,
      unsubscribed_count,
    })

    makeAutoObservable(this)
  }

  get filters() {
    return this.broadcastBaseStatistic.filters
  }
}
